import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Information } from 'src/app/helpers';
import { AuthService } from 'src/app/services/auth/auth.service';
import { InformationService } from 'src/app/services/information/information.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import * as moment from 'moment';
import { EMPTY, Subscription, of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { NgxImageCompressService } from 'ngx-image-compress';
import { environment } from 'src/environments/environment';
import { editableRole } from 'src/app/helpers/enums/role-type.enum';
import { IsDeviceOnlineService } from 'src/app/services/is-online/is-online.service';
import { EstimatesService } from 'src/app/services/estimates/estimates.service';
import { AutoDataService } from 'src/app/services/auto-data/auto-data.service';
declare var $: any;

interface vehicle_info {
  vehicle_id: string;
}
@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {
  // Loading flags
  public makeLoaded: boolean = false;
  public engineLoaded: boolean = false;
  public vehicleTypeLoaded: boolean = false;
  public modelTypeLoaded: boolean = false;
  public modelYearLoaded: boolean = false;
  public ccLoaded: boolean = false;
  public cyllindersLoaded: boolean = false;
  public bodyTypeLoaded: boolean = false;
  public transamissionTypeLoaded: boolean = false;
  public assessmentTypeLoaded: boolean = false;
  public driveTypeLoaded: boolean = false;
  public exteriorColourLoaded: boolean = false;
  public interiorColourLoaded: boolean = false;
  public utilityTypeLoaded: boolean = false;
  public doorsTypeLoaded: boolean = false;
  public engineTypeLoaded: boolean = false;
  public vendorTypeLoaded: boolean = false;
  public estimaraTypeLoaded: boolean = false;
  public trimTypeLoaded: boolean = false;
  public codTypeLoaded: boolean = false;
  public warrantyTypeLoaded: boolean = false;
  public wheelBaseLoaded: boolean = false;
  public uphoisteryLoaded: boolean = false;
  public fuelLoaded: boolean = false;
  public seatsLoaded: boolean = false;
  public gearsLoaded: boolean = false;
  public serviceLoaded: boolean = false;
  public conditionLoaded: boolean = false;
  public originLoaded: boolean = false;
  public ownershipLoaded: boolean = false;
  public mortgageLoaded: boolean = false;
  public mileageLoaded: boolean = false;
  public maxSpeedLoaded: boolean = false;
  public hpLoaded: boolean = false;
  public torqueLoaded: boolean = false;
  public accelerationLoaded: boolean = false;
  public loaded: boolean = false;

  public uploading: boolean = false;
  // END

  public disableForm: boolean = false;
  public submitted = false;
  public submitLoad = false;
  public informationForm: UntypedFormGroup = null;
  public uploader: UntypedFormGroup = null;
  public vehicle_info: vehicle_info = {
    vehicle_id: null
  };
  public itemCode: string = null;
  public vinInfo: Information = new Information();
  public informationAll: Object = {};

  public make: any[] = [];
  public models: any[] = [];
  public engine: any[] = [];
  public vehicle_type: any[] = [];
  public model_year: any[] = [];
  public body_type: any[] = [];
  public engine_cc: any[] = [];
  public cyllinders: any[] = [];
  public transamission_type: any[] = [];
  public assessment_type: any[] = [];
  public drive_type: any[] = [];
  public exterior_type: any[] = [];
  public interior_type: any[] = [];
  public utility_type: any[] = [];
  public doors_type: any[] = [];
  public engine_type: any[] = [];
  public estimara_type: any[] = [];
  public trim_type: any[] = [];
  public cod_type: any[] = [];
  public warranty_type: any[] = [];
  public wheel_base: any[] = [];
  public uphoistery: any[] = [];
  public fuel: any[] = [];
  public seats: any[] = [];
  public gears: any[] = [];
  public services: any[] = [];
  public conditions: any[] = [];
  public origins: any[] = [];
  public ownerships: any[] = [];
  public mortgages: any[] = [];
  public mileages: any[] = [];
  public maxSpeed: any[] = [];
  public hp: any[] = [];
  public torque: any[] = [];
  public acceleration: any[] = [];

  public role: any = null;
  public userData: any = null;
  public lang: string = null;

  // Preview modal
  public title: string = null;
  public fieldType: string = null;
  public preview: object = {
    vin: null,
    plate: null,
    odo: null,
    mvpi_expiry_date: null,
    estimara_expiry_date: null
  };
  public imagePreviewCurrent: string | ArrayBuffer = null;
  public file: File = null;
  public modalRef: BsModalRef = null;

  @ViewChild(ModalDirective, { static: false }) upload: ModalDirective;
  @ViewChild('confirm', { static: false }) confirm: ModalDirective;
  // END

  public dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  public subscriptions: Subscription[] = [];
  public dropdownList = [];
  public selectedItems: any = [];
  public editableRole: string[] = [];

  constructor(
    public formBuilder: UntypedFormBuilder,
    public router: Router,
    public location: Location,
    public informationService: InformationService,
    public ratingService: RatingService,
    public userService: UserService,
    public authService: AuthService,
    public sharedService: SharedService,
    public estimateService: EstimatesService,
    public localeService: LocaleService,
    public toastr: ToastrService,
    public autoData: AutoDataService,
    private imageCompress: NgxImageCompressService,
    private readonly _isDeviceOnlineService: IsDeviceOnlineService
  ) {
    this.editableRole = editableRole;
    // Resetting the vinInfo object in ls to reset the warning modal
    localStorage.removeItem('vinInfo');
    this.sharedService.vinInformation.next(null);

    this.getUserData();

    this.informationForm = this.formBuilder.group({
      vin_number: [
        '',
        [
          Validators.required,
          Validators.maxLength(21),
          Validators.pattern(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/) //Alphanumeric RegExp
        ]
      ],
      plate_number: [
        '',
        [Validators.required, Validators.pattern(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9 ]+)$/)]
      ],
      assessment_type_id: ['', [Validators.required]],
      make_id: ['', [Validators.required]],
      engine_type_id: ['', [Validators.required]],
      vendor_id: ['', [Validators.required, Validators.pattern(/^[a-zA-Z ]+$/)]],
      model_id: ['', [Validators.required]],
      engine_cc_id: ['', [Validators.required]],
      estimara_id: ['', [Validators.required]],
      trim_id: ['', [Validators.required]],
      cyllinder_id: ['', [Validators.required]],
      estimara_expiry_date: ['', [Validators.required]],
      vehicle_type_id: ['', [Validators.required]],
      transmission_type_id: ['', [Validators.required]],
      mvpi_expiry_date: [''], // [Validators.required]
      body_type_id: ['', [Validators.required]],
      wheel_base_id: ['', [Validators.required]],
      drive_type_id: ['', [Validators.required]],
      warranty_id: ['', [Validators.required]],
      model_year_id: ['', [Validators.required]],
      exterior_color_id: ['', [Validators.required]],
      gear_id: ['', [Validators.required]],
      warranty_expiry_date: [''], // [Validators.required]
      odo: ['', [Validators.required, Validators.pattern(/^[0-9.]+$/)]],
      interior_color_id: ['', [Validators.required]],
      last_service_date: [''], // [Validators.required]
      utility_type_id: ['', [Validators.required]],
      door_type_id: ['', [Validators.required]],
      seat_id: ['', [Validators.required]],
      last_service_km: [''], // [Validators.required, Validators.pattern(/^[0-9.]+$/)]
      vehicle_condition_id: ['', [Validators.required]],
      fuel_type_id: ['', [Validators.required]],
      uphoistery_id: ['', [Validators.required]],
      power_id: ['', [Validators.required]],
      torque_id: ['', [Validators.required]],
      acceleration_id: ['', [Validators.required]],
      cod_id: ['', [Validators.required]],
      service_maintainance: ['', [Validators.required]],
      max_speed: ['', [Validators.required]],
      vehicle_origin_id: ['', [Validators.required]],
      mileage_id: ['', [Validators.required]],
      ownership_id: ['', [Validators.required]],
      mortage_id: ['', [Validators.required]],
      contract_number: [''],
      external_estimator: [''],
      market_acceptabilitie_id: '',
      test_drive_video: ['']
    });

    this.uploader = this.formBuilder.group({
      infoImage: ['']
    });

    this.dpConfig.dateInputFormat = 'DD-MM-YYYY';
    this.dpConfig.adaptivePosition = true;
    this.dpConfig.showWeekNumbers = false;
  }

  public dropdownSettings: IDropdownSettings = {};

  ngOnInit(): void {
    this.getExtrenalEstimator(null);

    // SetTimeout is for Standalone VAM only.
    setTimeout(() => {
      this.callToAPIs();

      this.localeService.localeSubject.subscribe((res) => {
        if (res) {
          this.lang = res;
        }
      });
    }, 10);

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All'
      // itemsShowLimit: 3,
      // allowSearchFilter: true
    };

    if (['purchaser', 'purchasemanager', 'salesperson', 'salesmanager'].includes(this.role)) {
      this.informationForm.controls['market_acceptabilitie_id'].disable();
    }

    // Start - Enable/Disable Form
    const payload = { vehicle_id: this.sharedService.getVehicleId };

    this.informationService.getVehicleStatus(payload).subscribe((res: object) => {
      const vehicleStatus = Object.values(res['data']);

      // vehicleStatus.every((status: boolean) => status === true)
      // this.disableForm = res['data']['gallery'];
      if (this.disableForm === true && !editableRole.includes(this.role)) {
        this.informationForm.disable();
      }
    });
    // End
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  get formData() {
    return this.informationForm.controls;
  }

  getUserData() {
    const userDataSub = this.authService.userSubject.subscribe((res) => {
      let user: any = res && res.user ? res.user : null;

      this.userData = user ? user.user_data : null;
      this.role = user && user.user_data ? user.user_data.role : 'admin';
    });

    this.subscriptions.push(userDataSub);
  }

  // onItemSelect(item: any) {
  //   // console.log(item);
  // }
  // onSelectAll(items: any) {
  //   console.log(items);
  // }

  allLoaded(test?: string) {
    if (
      !this.makeLoaded &&
      !this.conditionLoaded &&
      !this.vehicleTypeLoaded &&
      !this.ccLoaded &&
      !this.bodyTypeLoaded &&
      !this.transamissionTypeLoaded &&
      !this.serviceLoaded &&
      !this.assessmentTypeLoaded &&
      !this.driveTypeLoaded &&
      !this.exteriorColourLoaded &&
      !this.interiorColourLoaded &&
      !this.utilityTypeLoaded &&
      !this.doorsTypeLoaded &&
      !this.engineTypeLoaded &&
      !this.vendorTypeLoaded &&
      !this.estimaraTypeLoaded &&
      !this.codTypeLoaded &&
      !this.warrantyTypeLoaded &&
      !this.wheelBaseLoaded &&
      !this.uphoisteryLoaded &&
      !this.fuelLoaded &&
      !this.seatsLoaded &&
      !this.gearsLoaded &&
      !this.originLoaded &&
      !this.ownershipLoaded &&
      !this.mortgageLoaded &&
      !this.mileageLoaded &&
      !this.maxSpeedLoaded &&
      !this.hpLoaded &&
      !this.torqueLoaded &&
      !this.accelerationLoaded
    ) {
      this.getVinDetails();
      // this.getNewVin();
    }
  }

  callToAPIs() {
    this.loaded = true;
    this.getAssessmentType();
    this.getMakeType();
    this.getConditions();
    this.getEngineType();
    this.getCcType();
    this.getEstimaraType();
    this.getService();
    this.getVehicleType();
    this.getTransmissionType();
    this.getBodyType();
    this.getWarrantyType(); // not sure where is this being used
    this.getDriveType();
    this.getExteriorColourType();
    this.getInteriorColourType();
    this.getUtilityType();
    this.getDoorsType();
    this.getCODType();
    this.getWheelBase();
    this.getCyllinders();
    this.getUphoistery();
    this.getFuel();
    this.getSeats();
    this.getGears();
    this.getOrigin();
    this.getOwnership();
    this.getMortgage(); // to be implemented
    this.getMileage();
    this.getMaxSpeed(); // <-- here

    this.getHP();
    this.getTorque();
    this.getAcceleration();
    this.getMarketAcceptability();
  }
  // getNewVin() {
  //   this.userService.NewGetVinInfo().subscribe((res) => {
  //     const success: boolean = res['success'];
  //     const data = res['data'];
  //     console.log("New Get Vin Info-", data);
  //   })
  // }

  getVinDetails() {
    this.vehicle_info.vehicle_id = this.sharedService.getVehicleId;
    const informationSub = this.userService.GetVinInfo(this.vehicle_info).subscribe(
      (res) => {
        let success = res['success'];
        let data = res['data'];

        if (success && Object.keys(data).length) {
          let vehicleDetails: Object = data['vehicle_details'];
          let vehicleInformation: Object = data['vehicle_information'];
          this.vinInfo.is_salvage = vehicleDetails['is_salvage'];
          this.vinInfo.vin_number = vehicleDetails['vin_number'];
          this.vinInfo.plate_number = vehicleDetails['plate_number'];
          this.vinInfo.odo = vehicleDetails['odo_value'] || '';
          this.vinInfo.mvpi_expiry_date = vehicleDetails['mvpi_expiry_date']
            ? moment(vehicleDetails['mvpi_expiry_date'], 'Y-M-D').format('DD-MM-YYYY')
            : '';
          this.vinInfo.estimara_expiry_date = vehicleDetails['estimara_expiry_date']
            ? moment(vehicleDetails['estimara_expiry_date'], 'Y-M-D').format('DD-MM-YYYY')
            : '';
          if (
            this.role === 'admin' ||
            this.role === 'estimator' ||
            this.role === 'qc' ||
            this.role === 'purchasemanager'
          ) {
            this.hijriChecker(this.vinInfo.estimara_expiry_date, 'estemara');
            this.hijriChecker(this.vinInfo.mvpi_expiry_date, 'mvpi');
          }

          this.informationForm.get('vin_number').setValue(this.vinInfo.vin_number);
          this.informationForm.get('plate_number').setValue(this.vinInfo.plate_number);
          this.informationForm.get('odo').setValue(this.vinInfo.odo);
          this.informationForm
            .get('estimara_expiry_date')
            .setValue(this.vinInfo.estimara_expiry_date);
          this.informationForm.get('mvpi_expiry_date').setValue(this.vinInfo.mvpi_expiry_date);

          if (vehicleInformation && Object.keys(vehicleInformation).length) {
            // Input only
            this.vinInfo.warranty_expiry_date = vehicleInformation['warranty_expiry_date']
              ? moment(vehicleInformation['warranty_expiry_date'], 'Y-M-D').format('DD-MM-YYYY')
              : '';
            this.vinInfo.last_service_date = vehicleInformation['last_service_date']
              ? moment(vehicleInformation['last_service_date'], 'Y-M-D').format('DD-MM-YYYY')
              : '';
            this.vinInfo.vendor_id = vehicleInformation['vendor_id'] || '';
            this.vinInfo.last_service_km = vehicleInformation['last_service_km'] || '';
            // END

            // Select only
            this.vinInfo.assessment_type_id = vehicleInformation['assessment_type_id'] || '';
            this.vinInfo.make_id = vehicleInformation['make_id'] || '';
            this.vinInfo.model_id = vehicleInformation['model_id'] || '';
            this.vinInfo.engine_type_id = vehicleInformation['engine_type_id'] || '';
            this.vinInfo.engine_cc_id = vehicleInformation['engine_cc_id'] || '';
            this.vinInfo.estimara_id = vehicleInformation['estimara_id'] || '';
            this.vinInfo.trim_id = vehicleInformation['trim_id'] || '';
            this.vinInfo.cyllinder_id = vehicleInformation['cyllinder_id'] || '';
            this.vinInfo.vehicle_type_id = vehicleInformation['vehicle_type_id'] || '';
            this.vinInfo.transmission_type_id = vehicleInformation['transmission_type_id'] || '';
            this.vinInfo.body_type_id = vehicleInformation['body_type_id'] || '';
            this.vinInfo.wheel_base_id = vehicleInformation['wheel_base_id'] || '';
            this.vinInfo.drive_type_id = vehicleInformation['drive_type_id'] || '';
            this.vinInfo.warranty_id = vehicleInformation['warranty_id'] || '';
            this.vinInfo.model_year = vehicleInformation['year_id'] || '';
            this.vinInfo.exterior_color_id = vehicleInformation['exterior_color_id'] || '';
            this.vinInfo.gear_id = vehicleInformation['gear_id'] || '';
            this.vinInfo.interior_color_id = vehicleInformation['interior_color_id'] || '';
            this.vinInfo.utility_type_id = vehicleInformation['utility_type_id'] || '';
            this.vinInfo.door_type_id = vehicleInformation['door_type_id'] || '';
            this.vinInfo.seat_id = vehicleInformation['seat_id'] || '';
            this.vinInfo.vehicle_condition_id = vehicleInformation['vehicle_condition_id'] || '';
            this.vinInfo.fuel_type_id = vehicleInformation['fuel_type_id'] || '';
            this.vinInfo.uphoistery_id = vehicleInformation['uphoistery_id'] || '';
            this.vinInfo.cod_id = vehicleInformation['cod_id'] || '';
            this.vinInfo.service_maintainance = vehicleInformation['service_maintainance'] || '';
            this.vinInfo.max_speed = vehicleInformation['max_speed'] || '';
            this.vinInfo.power_id = vehicleInformation['power_id'] || '';
            this.vinInfo.torque_id = vehicleInformation['torque_id'] || '';
            this.vinInfo.acceleration_id = vehicleInformation['acceleration_id'] || '';
            this.vinInfo.origin = vehicleInformation['vehicle_origin_id'] || '';
            this.vinInfo.mileage = vehicleInformation['mileage_id'] || '';
            this.vinInfo.mortgage = vehicleInformation['mortage_id'] || '';
            this.vinInfo.ownership = vehicleInformation['ownership_id'] || '';
            // END

            // Input
            this.informationForm
              .get('warranty_expiry_date')
              .setValue(this.vinInfo.warranty_expiry_date);
            this.informationForm.get('last_service_date').setValue(this.vinInfo.last_service_date);
            this.informationForm.get('vendor_id').setValue(this.vinInfo.vendor_id);
            this.informationForm.get('last_service_km').setValue(this.vinInfo.last_service_km);

            // Select
            this.informationForm
              .get('assessment_type_id')
              .setValue(this.vinInfo.assessment_type_id);
            this.informationForm.get('make_id').setValue(this.vinInfo.make_id);
            this.informationForm.get('engine_type_id').setValue(this.vinInfo.engine_type_id);
            this.informationForm.get('engine_cc_id').setValue(this.vinInfo.engine_cc_id);
            this.informationForm.get('estimara_id').setValue(this.vinInfo.estimara_id);
            this.informationForm.get('cyllinder_id').setValue(this.vinInfo.cyllinder_id);
            this.informationForm.get('vehicle_type_id').setValue(this.vinInfo.vehicle_type_id);
            this.informationForm
              .get('transmission_type_id')
              .setValue(this.vinInfo.transmission_type_id);
            this.informationForm.get('body_type_id').setValue(this.vinInfo.body_type_id);
            this.informationForm.get('wheel_base_id').setValue(this.vinInfo.wheel_base_id);
            this.informationForm.get('warranty_id').setValue(this.vinInfo.warranty_id);
            this.informationForm.get('drive_type_id').setValue(this.vinInfo.drive_type_id);
            this.informationForm.get('exterior_color_id').setValue(this.vinInfo.exterior_color_id);
            this.informationForm.get('gear_id').setValue(this.vinInfo.gear_id);
            this.informationForm.get('interior_color_id').setValue(this.vinInfo.interior_color_id);
            this.informationForm.get('utility_type_id').setValue(this.vinInfo.utility_type_id);
            this.informationForm.get('door_type_id').setValue(this.vinInfo.door_type_id);
            this.informationForm.get('seat_id').setValue(this.vinInfo.seat_id);
            this.informationForm
              .get('vehicle_condition_id')
              .setValue(this.vinInfo.vehicle_condition_id);
            this.informationForm.get('fuel_type_id').setValue(this.vinInfo.fuel_type_id);
            this.informationForm.get('uphoistery_id').setValue(this.vinInfo.uphoistery_id);
            this.informationForm.get('cod_id').setValue(this.vinInfo.cod_id);
            this.informationForm
              .get('service_maintainance')
              .setValue(this.vinInfo.service_maintainance);
            this.informationForm.get('vehicle_origin_id').setValue(this.vinInfo.origin);
            this.informationForm.get('mileage_id').setValue(this.vinInfo.mileage);
            this.informationForm.get('mortage_id').setValue(this.vinInfo.mortgage);
            this.informationForm.get('ownership_id').setValue(this.vinInfo.ownership);
            this.informationForm.get('max_speed').setValue(this.vinInfo.max_speed);
            this.informationForm.get('power_id').setValue(this.vinInfo.power_id);
            this.informationForm.get('torque_id').setValue(this.vinInfo.torque_id);
            this.informationForm.get('acceleration_id').setValue(this.vinInfo.acceleration_id);
            this.informationForm
              .get('contract_number')
              .setValue(vehicleInformation['contract_number']);
            this.informationForm
              .get('market_acceptabilitie_id')
              .setValue(vehicleInformation['market_acceptabilitie_id']);
            this.informationForm
              .get('test_drive_video')
              .setValue(vehicleDetails['test_drive_video']);

            if (this.vinInfo.make_id && this.vinInfo.model_year) {
              this.getModelYearType(this.vinInfo.make_id)
                .then(async (res) => {
                  const data: object[] = await this.getModelType(
                    this.vinInfo.model_year,
                    this.vinInfo.make_id
                  );
                  if (data && data.length) return data;
                })
                .then(async (res) => {
                  const data: object[] = await this.getTrimType(this.vinInfo.model_id);

                  if (data && data.length) {
                    this.informationForm.get('model_id').setValue(this.vinInfo.model_id);
                    this.informationForm.get('model_year_id').setValue(this.vinInfo.model_year);
                    this.informationForm.get('trim_id').setValue(this.vinInfo.trim_id);
                    this.informationForm.updateValueAndValidity();
                  }

                  this.itemCodeSelector();
                });
            } else {
              this.itemCodeSelector();
            }
          } else {
            this.itemCodeSelector();
          }
        }
      },
      (error) => {}
    );
    this.subscriptions.push(informationSub);
  }

  itemCodeSelector() {
    setTimeout(() => {
      if (!this.modelTypeLoaded && !this.modelYearLoaded && !this.trimTypeLoaded) {
        this.removeValidationOnDisabled();
        this.sharedService.setVinInfo = {
          ...this.extractInformation(),
          is_salvage: this.vinInfo.is_salvage
        };

        const vin = this.vinInfo.vin_number;
        this.autoData.decodeVin(this.vinInfo.vin_number).subscribe(
          (res) => {
            if (res?.status) {
              const vinData = res?.data;
              delete vinData['trim'];

              Object.entries(vinData).forEach(([key, value]) => {
                console.log(`${key}: ${value}`, 'keyvalue');
                if (key === 'seats') {
                  this.vinInfo[`seat_id`] = value || '';
                  this.informationForm.get(`seat_id`).setValue(value);
                }
                if (key === 'cc') {
                  this.vinInfo[`engine_cc_id`] = value || '';
                  this.informationForm.get(`engine_cc_id`).setValue(value);
                }
                // if (key === 'model_year') {
                //   this.vinInfo[key] = value || '';
                //   this.informationForm.get('model_year_id')?.setValue(value);
                // }

                if (`${key}_id` in this.vinInfo) {
                  this.vinInfo[`${key}_id`] = value || '';
                  this.informationForm.get(`${key}_id`)?.setValue(value);
                }
                if (`${key}_type_id` in this.vinInfo) {
                  this.vinInfo[`${key}_type_id`] = value || '';
                  this.informationForm.get(`${key}_type_id`)?.setValue(value);
                }
              });

              this.getModelYearType(vinData?.make).then(async () => {
                if (this.model_year?.length) {
                  this.vinInfo['model_year'] = vinData?.model_year || '';
                  this.informationForm.get('model_year_id')?.setValue(vinData?.model_year);

                  await this.getModelType(this.vinInfo.model_year, this.vinInfo.make_id);

                  this.vinInfo['model_id'] = vinData?.model || '';
                  this.informationForm.get('model_id')?.setValue(vinData?.model);

                  await this.getTrimType(this.vinInfo.model_id);

                  // this.vinInfo['trim_id'] = vinData?.trim || '';
                  // this.informationForm.get('trim_id')?.setValue(vinData?.trim);
                }
              });
            }
          },
          (error) => {
            console.error(error, 'autoData error');
          }
        );
        this.loaded = false;
      }
    }, 0);
  }

  // Getting all the select input type values from apis
  // Filtering API
  getMakeType() {
    this.makeLoaded = true;
    const getMakeInfoSub = this.informationService.GetMakeInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.makeLoaded = false;
        this.make = data;
        this.allLoaded('Make');
      }
    });
    this.subscriptions.push(getMakeInfoSub);
  }

  getModelType(ev: any, ...args: any[]): Promise<object[]> {
    let value: string = ev.target ? ev.target.value : ev;
    let [makeId] = args;
    let data: object = {
      make_id: makeId,
      year_id: value
    };

    this.modelTypeLoaded = true;
    return new Promise((resolve, reject) => {
      const getModelInfoSub = this.informationService.GetModelInfo(data).subscribe((res) => {
        let success: boolean = res['success'];
        let data: any[] = res['data'];

        if (success) {
          this.models = data;
          this.modelTypeLoaded = false;

          setTimeout(() => {
            resolve(this.models);
          }, 0);
        } else {
          reject(res);
        }
      });
      this.subscriptions.push(getModelInfoSub);
    });
  }

  getModelYearType(ev: any): Promise<object[]> {
    let value: string = ev.target ? ev.target.value : ev;
    let data: object = {
      make_id: value
    };

    this.modelYearLoaded = true;
    return new Promise((resolve, reject) => {
      const getModelYearInfoSub = this.informationService
        .GetModelYearInfo(data)
        .subscribe((res) => {
          let success: boolean = res['success'];
          let data: any[] = res['data'];

          if (success) {
            this.model_year = data;
            this.modelYearLoaded = false;

            if (typeof ev === 'object') {
              this.trim_type = [];
              this.models = [];

              this.informationForm.get('model_id').setValue('');
              this.informationForm.get('trim_id').setValue('');
              this.informationForm.get('model_year_id').setValue('');
            }

            setTimeout(() => {
              resolve(this.model_year);
            }, 0);
          } else {
            reject(res);
          }
        });
      this.subscriptions.push(getModelYearInfoSub);
    });
  }

  getTrimType(ev: any): Promise<object[]> {
    let value: string = ev.target ? ev.target.value : ev;
    let data: object = {
      model_id: value
    };

    this.trimTypeLoaded = true;
    return new Promise((resolve, reject) => {
      const getTrimInfoSub = this.informationService.GetTrimInfo(data).subscribe((res) => {
        let success: boolean = res['success'];
        let data: any[] = res['data'];

        if (success) {
          this.trimTypeLoaded = false;
          this.trim_type = data;
          resolve(this.trim_type);
        } else {
          reject(res);
        }
      });
      this.subscriptions.push(getTrimInfoSub);
    });
  }
  // END

  getEngineType() {
    this.engineTypeLoaded = true;
    const getEngineInfoSub = this.informationService.GetEngineInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.engineTypeLoaded = false;
        this.engine = data;
        this.allLoaded('Engine');
      }
    });
    this.subscriptions.push(getEngineInfoSub);
  }

  getCcType() {
    this.ccLoaded = true;
    const getCcInfoSub = this.informationService.GetCcInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.engine_cc = data;
        this.ccLoaded = false;
        this.allLoaded('CC');
      }
    });
    this.subscriptions.push(getCcInfoSub);
  }

  getCyllinders() {
    this.cyllindersLoaded = true;
    const getCcInfoSub = this.informationService.GetCyllinders().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.cyllinders = data;
        this.cyllindersLoaded = false;
        this.allLoaded('Cyllinder');
      }
    });
    this.subscriptions.push(getCcInfoSub);
  }

  getEstimaraType() {
    this.estimaraTypeLoaded = true;
    const getEstimaraInfoSub = this.informationService.GetEstimaraInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.estimaraTypeLoaded = false;
        this.estimara_type = data;
        this.allLoaded('Estimara');
      }
    });
    this.subscriptions.push(getEstimaraInfoSub);
  }

  getVehicleType() {
    this.vehicleTypeLoaded = true;
    const getVehicleInfoSub = this.informationService.GetVehicleInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.vehicleTypeLoaded = false;
        this.vehicle_type = data;
        this.allLoaded('Vehicle Type');
      }
    });
    this.subscriptions.push(getVehicleInfoSub);
  }

  getTransmissionType() {
    this.transamissionTypeLoaded = true;
    const getTransmissionInfoSub = this.informationService
      .GetTransmissionInfo()
      .subscribe((res) => {
        let success: boolean = res['success'];
        let data: any[] = res['data'];

        if (success) {
          this.transamissionTypeLoaded = false;
          this.transamission_type = data;
          this.allLoaded('Transmission');
        }
      });
    this.subscriptions.push(getTransmissionInfoSub);
  }

  getBodyType() {
    this.bodyTypeLoaded = true;
    const getBodyInfoSub = this.informationService.GetBodyInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.bodyTypeLoaded = false;
        this.body_type = data;
        this.allLoaded('Body');
      }

      this.subscriptions.push(getBodyInfoSub);
    });
  }

  getDriveType() {
    this.driveTypeLoaded = true;
    const getDriveInfoSub = this.informationService.GetDriveInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.driveTypeLoaded = false;
        this.drive_type = data;
        this.allLoaded('Drive');
      }
    });
    this.subscriptions.push(getDriveInfoSub);
  }

  getWarrantyType() {
    this.warrantyTypeLoaded = true;
    const getWarrantyInfoSub = this.informationService.GetWarrantyInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.warrantyTypeLoaded = false;
        this.warranty_type = data;
        this.allLoaded('Warranty');
      }
    });
    this.subscriptions.push(getWarrantyInfoSub);
  }

  getExteriorColourType() {
    this.exteriorColourLoaded = true;
    const getExteriorColourInfoSub = this.informationService
      .GetExteriorColourInfo()
      .subscribe((res) => {
        let success: boolean = res['success'];
        let data: any[] = res['data'];

        if (success) {
          this.exteriorColourLoaded = false;
          this.exterior_type = data;
          this.allLoaded('Exterior');
        }
      });
    this.subscriptions.push(getExteriorColourInfoSub);
  }

  getInteriorColourType() {
    this.interiorColourLoaded = true;
    const getInteriorColourInfoSub = this.informationService
      .GetInteriorColourInfo()
      .subscribe((res) => {
        let success: boolean = res['success'];
        let data: any[] = res['data'];

        if (success) {
          this.interiorColourLoaded = false;
          this.interior_type = data;
          this.allLoaded('Interior');
        }
      });
    this.subscriptions.push(getInteriorColourInfoSub);
  }

  getUtilityType() {
    this.utilityTypeLoaded = true;
    const getUtilityInfoSub = this.informationService.GetUtilityInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.utilityTypeLoaded = false;
        this.utility_type = data;
        this.allLoaded('Utility');
      }
    });
    this.subscriptions.push(getUtilityInfoSub);
  }

  getDoorsType() {
    this.doorsTypeLoaded = true;
    const getDoorsInfoSub = this.informationService.GetDoorsInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.doorsTypeLoaded = false;
        this.doors_type = data;
        this.allLoaded('Doors');
      }
    });
    this.subscriptions.push(getDoorsInfoSub);
  }

  getCODType() {
    this.codTypeLoaded = true;
    const getCODInfoSub = this.informationService.GetCODInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.codTypeLoaded = false;
        this.cod_type = data;
        this.allLoaded('COD');
      }
    });
    this.subscriptions.push(getCODInfoSub);
  }

  getAssessmentType() {
    this.assessmentTypeLoaded = true;
    const getAssessmentInfoSub = this.informationService.GetAssessmentInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.assessmentTypeLoaded = false;
        this.assessment_type = data;
        this.allLoaded('Assessment');
      }
    });
    this.subscriptions.push(getAssessmentInfoSub);
  }

  getWheelBase() {
    this.wheelBaseLoaded = true;
    const wheeBaseSub = this.informationService.GetWheelBase().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.wheelBaseLoaded = false;
        this.wheel_base = data;
        this.allLoaded('Wheel Base');
      }
    });
    this.subscriptions.push(wheeBaseSub);
  }

  getUphoistery() {
    this.uphoisteryLoaded = true;
    const uphoisterySub = this.informationService.GetUphoistry().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.uphoisteryLoaded = false;
        this.uphoistery = data;
        this.allLoaded('Upholstery');
      }
    });
    this.subscriptions.push(uphoisterySub);
  }

  getFuel() {
    this.fuelLoaded = true;
    const fuelSub = this.informationService.GetFuelType().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.fuelLoaded = false;
        this.fuel = data;
        this.allLoaded('Fuel');
      }
    });
    this.subscriptions.push(fuelSub);
  }

  getSeats() {
    this.seatsLoaded = true;
    const seatsSub = this.informationService.GetSeats().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.seatsLoaded = false;
        this.seats = data;
        this.allLoaded('Seats');
      }
    });
    this.subscriptions.push(seatsSub);
  }

  getGears() {
    this.gearsLoaded = true;
    const gearsSub = this.informationService.GetGearInfo().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.gearsLoaded = false;
        this.gears = data;
        this.allLoaded('gears');
      }
    });
    this.subscriptions.push(gearsSub);
  }

  getService() {
    this.serviceLoaded = true;
    const serviceSub = this.informationService.GetService().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.serviceLoaded = false;
        this.services = data;
        this.allLoaded('Service');
      }
    });
    this.subscriptions.push(serviceSub);
  }

  getConditions() {
    this.conditionLoaded = true;
    const conditionSub = this.informationService.GetCondition().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.conditionLoaded = false;
        this.conditions = data;
        this.allLoaded('conditions');
      }
    });
    this.subscriptions.push(conditionSub);
  }

  getOrigin() {
    this.originLoaded = true;
    const originSub = this.informationService.GetOrigin().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.originLoaded = false;
        this.origins = data;
        this.allLoaded('origin');
      }
    });
    this.subscriptions.push(originSub);
  }

  getOwnership() {
    this.ownershipLoaded = true;
    const ownershipSub = this.informationService.GetOwnership().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.ownershipLoaded = false;
        this.ownerships = data;
        this.allLoaded('ownership');
      }
    });
    this.subscriptions.push(ownershipSub);
  }

  getMortgage() {
    this.mortgageLoaded = true;
    const mortgageSub = this.informationService.GetMortgage().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.mortgageLoaded = false;
        this.mortgages = data;
        this.allLoaded('mortgage');
      }
    });
    this.subscriptions.push(mortgageSub);
  }

  getMileage() {
    this.mileageLoaded = true;
    const mileageSub = this.informationService.GetMileage().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.mileageLoaded = false;
        this.mileages = data;
        this.allLoaded('mileage');
      }
    });
    this.subscriptions.push(mileageSub);
  }

  getMaxSpeed() {
    this.maxSpeedLoaded = true;
    const maxSpeedSub = this.informationService.GetMaxSpeed().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.maxSpeedLoaded = false;
        this.maxSpeed = data;
        this.allLoaded('maxSpeed');
      }
    });
    this.subscriptions.push(maxSpeedSub);
  }

  getHP() {
    this.hpLoaded = true;
    const hpSub = this.informationService.GetHP().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.hpLoaded = false;
        this.hp = data;
        this.allLoaded('hp');
      }
    });
    this.subscriptions.push(hpSub);
  }

  getTorque() {
    this.torqueLoaded = true;
    const torqueSub = this.informationService.GetTorque().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.torqueLoaded = false;
        this.torque = data;
        this.allLoaded('torque');
      }
    });
    this.subscriptions.push(torqueSub);
  }

  getAcceleration() {
    this.accelerationLoaded = true;
    const accelerationSub = this.informationService.GetAcceleration().subscribe((res) => {
      let success: boolean = res['success'];
      let data: any[] = res['data'];

      if (success) {
        this.accelerationLoaded = false;
        this.acceleration = data;
        this.allLoaded('acceleration');
      }
    });
    this.subscriptions.push(accelerationSub);
  }
  // END

  getFile(evt: Event) {
    let target: any = evt.target;
    let fileObj: File = target['files'][0];
    let reader: FileReader = new FileReader();
    let fileFormatCheck: boolean =
      fileObj.type == 'image/png' ||
      fileObj.type == 'image/jpg' ||
      fileObj.type == 'image/jpeg' ||
      fileObj.type == 'image/webp';

    if (fileFormatCheck) {
      reader.readAsDataURL(fileObj);
      reader.onload = (ev) => {
        let base64: any = ev.target.result;
        this.imageCompression(base64, fileObj.name);
      };
    } else return false;
  }

  imageCompression(base64: string, fileName: string) {
    this.imageCompress.compressFile(base64, -1, 60, 50).then((res) => {
      const imageBlob = this.sharedService.dataURItoBlob(res.split(',')[1]);
      this.file = new File([imageBlob], fileName, { type: 'image/jpeg' });
    });
  }

  openUpload(ev: Event, fieldType: string) {
    this.file = null;
    this.title = ev.currentTarget['id'];
    this.fieldType = fieldType;

    const informationSub2 = this.userService.GetVinInfo(this.vehicle_info).subscribe((res) => {
      let success = res['success'];
      let data = res['data'];

      if (success && Object.keys(data).length) {
        let vehicleDetails: Object = data['vehicle_details'];
        let url: string = `${environment.base_path}storage/vehicle/`;

        if (this._isDeviceOnlineService.currentNetwork === 'online') {
          this.preview['vin'] = vehicleDetails['vin_image']
            ? `${url}vinimage/${vehicleDetails['vin_image']}`
            : null;
          this.preview['plate'] = vehicleDetails['plate_image']
            ? `${url}plateimage/${vehicleDetails['plate_image']}`
            : null;
          this.preview['odo'] = vehicleDetails['odo_image']
            ? `${url}odo-image/${vehicleDetails['odo_image']}`
            : null;
          this.preview['mvpi_expiry_date'] = vehicleDetails['mvpi_image']
            ? `${url}mvpiimage/${vehicleDetails['mvpi_image']}`
            : null;
          this.preview['estimara_expiry_date'] = vehicleDetails['estimara_image']
            ? `${url}estimaraimage/${vehicleDetails['estimara_image']}`
            : null;
        } else {
          this.preview['vin'] = vehicleDetails['vin_image']
            ? `${vehicleDetails['vin_image']}`
            : null;
          this.preview['plate'] = vehicleDetails['plate_image']
            ? `${vehicleDetails['plate_image']}`
            : null;
          this.preview['odo'] = vehicleDetails['odo_image']
            ? `${vehicleDetails['odo_image']}`
            : null;
          this.preview['mvpi_expiry_date'] = vehicleDetails['mvpi_image']
            ? `${vehicleDetails['mvpi_image']}`
            : null;
          this.preview['estimara_expiry_date'] = vehicleDetails['estimara_image']
            ? `${vehicleDetails['estimara_image']}`
            : null;
        }

        switch (fieldType) {
          case 'vin':
            this.imagePreviewCurrent = this.preview['vin'];
            break;
          case 'plate':
            this.imagePreviewCurrent = this.preview['plate'];
            break;
          case 'odo':
            this.imagePreviewCurrent = this.preview['odo'];
            break;
          case 'mvpi_expiry_date':
            this.imagePreviewCurrent = this.preview['mvpi_expiry_date'];
            break;
          case 'estimara_expiry_date':
            this.imagePreviewCurrent = this.preview['estimara_expiry_date'];
            break;
        }
        this.upload.show();
      }
    });

    this.subscriptions.push(informationSub2);
  }

  saveImg(fieldType: string) {
    //appending to formData
    const form: FormData = new FormData();

    switch (fieldType) {
      case 'vin':
        form.set('vin_image', this.file);
        // form.set('plate_image', '');
        // form.set('mvpi_image', '');
        // form.set('estimara_image', '');
        // form.set('odo_image', '');
        break;
      case 'plate':
        form.set('plate_image', this.file);
        // form.set('vin_image', '');
        // form.set('mvpi_image', '');
        // form.set('estimara_image', '');
        // form.set('odo_image', '');
        break;
      case 'odo':
        form.set('odo_image', this.file);
        // form.set('plate_image', '');
        // form.set('vin_image', '');
        // form.set('mvpi_image', '');
        // form.set('estimara_image', '');
        break;
      case 'mvpi_expiry_date':
        form.set('mvpi_image', this.file);
        // form.set('vin_image', '');
        // form.set('plate_image', '');
        // form.set('odo_image', '');
        // form.set('estimara_image', '');
        break;
      case 'estimara_expiry_date':
        form.set('estimara_image', this.file);
        // form.set('vin_image', '');
        // form.set('plate_image', '');
        // form.set('odo_image', '');
        // form.set('mvpi_image', '');
        break;
    }

    // form.set('odo_value', '');
    // form.set('estimara_expiry_date', '');
    // form.set('mvpi_expiry_date', '');
    form.set('vehicle_id', <string>this.vehicle_info.vehicle_id);

    this.submitLoad = true;
    this.userService.PostValidation(form).subscribe(
      (res) => {
        let success = res['success'];

        if (success) {
          this.submitLoad = false;
          this.imagePreviewCurrent = null;
          this.toastr.success('Car details validated succssfully!', 'Success');
          this.upload.hide();
        } else {
          this.submitLoad = false;
          this.toastr.error('Something went wrong.', 'Error');
        }
      },
      (error) => {
        this.submitLoad = false;
        this.toastr.error(`${error.error.message}`, 'Error');
      }
    );
  }

  bodyTypeChecker(ev: Event) {
    let value: string = ev.target['value'];

    if (this.vinInfo.body_type_id && value !== this.vinInfo.body_type_id) {
      this.confirm.show();
    }
  }

  deleteBodyTypeData(bodyTypeId: string) {
    if (this.vinInfo.body_type_id && this.vinInfo.body_type_id !== bodyTypeId) {
      let data: object = {
        vehicle_id: this.sharedService.getVehicleId,
        body_type_id: this.vinInfo.body_type_id
      };

      this.ratingService.deleteRatingStates(data).subscribe(
        (res) => {},
        (error: HttpErrorResponse) => {}
      );
    }
  }

  removeValidationOnDisabled() {
    let disabledField: HTMLElement[] = Array.from(document.querySelectorAll('[disabled="true"]'));

    disabledField.forEach((elem: HTMLElement, index: number) => {
      const formControlName: string = elem.getAttribute('formControlName');

      this.informationForm.get(formControlName).clearValidators();
      this.informationForm.get(formControlName).updateValueAndValidity();
    });

    if (this.role == 'evaluator') {
      this.informationForm.get('estimara_expiry_date').clearValidators();
      this.informationForm.get('mvpi_expiry_date').clearValidators();
      this.informationForm.get('warranty_id').clearValidators();
      this.informationForm.get('warranty_expiry_date').clearValidators();
      this.informationForm.get('last_service_date').clearValidators();
      this.informationForm.get('last_service_km').clearValidators();
      this.informationForm.get('power_id').clearValidators();
      this.informationForm.get('torque_id').clearValidators();
      this.informationForm.get('acceleration_id').clearValidators();

      this.informationForm.get('estimara_expiry_date').updateValueAndValidity();
      this.informationForm.get('mvpi_expiry_date').updateValueAndValidity();
      this.informationForm.get('warranty_id').updateValueAndValidity();
      this.informationForm.get('warranty_expiry_date').updateValueAndValidity();
      this.informationForm.get('last_service_date').updateValueAndValidity();
      this.informationForm.get('last_service_km').updateValueAndValidity();
      this.informationForm.get('power_id').updateValueAndValidity();
      this.informationForm.get('torque_id').updateValueAndValidity();
      this.informationForm.get('acceleration_id').updateValueAndValidity();
    }
  }

  extractInformation() {
    const extractedInfo: Object = {};
    let allSelectControl: HTMLSelectElement[] = Array.from(
      document.querySelectorAll('select[name]')
    );

    let allInputControl: HTMLInputElement[] = Array.from(document.querySelectorAll('input[name]'));

    allSelectControl.forEach((elem: HTMLSelectElement, index: number) => {
      extractedInfo[elem.name] = {
        id:
          elem.options[elem.selectedIndex] && elem.options[elem.selectedIndex].value
            ? elem.options[elem.selectedIndex].value
            : null,
        value:
          elem.options[elem.selectedIndex] && elem.options[elem.selectedIndex].value
            ? elem.options[elem.selectedIndex].text
            : null
      };
    });

    allInputControl.forEach((elem: HTMLInputElement, index: number) => {
      if (elem.name.match('date')) {
        //   `${elem.name} --> ${this.informationForm.get(elem.name).value}`
        // );
        extractedInfo[elem.name] = {
          id: null,
          value: this.informationForm.get(elem.name).value
        };
      } else {
        extractedInfo[elem.name] = {
          id: null,
          value: elem.value
        };
      }
    });

    this.itemCode =
      `${extractedInfo['make_id'].value || ''}` +
      ` ${extractedInfo['model_id'].value || ''}` +
      ` ${extractedInfo['cyllinder_id'].value || ''}` +
      ` ${extractedInfo['trim_id'].value || ''}` +
      ` ${extractedInfo['model_year_id'].value || ''}`;
    extractedInfo['vehicle_item_code'] = this.itemCode.trim();

    return extractedInfo;
  }

  estExpToggle: boolean = false;
  mvpiExpToggle: boolean = false;
  dpToggle(type: string) {
    switch (type) {
      case 'estemara':
        const estDate = this.vinInfo.estimara_expiry_date || '';
        const hijriYearEst: string | number = moment(
          this.vinInfo.estimara_expiry_date,
          'DD-MM-YYYY'
        ).year();
        this.estExpToggle = !this.estExpToggle;

        if (this.estExpToggle) {
          setTimeout(() => {
            // Islamic DP
            $('#est_exp_date').hijriDatePicker({
              hijri: true,
              hijriFormat: 'iD-iM-iYYYY',
              locale: 'en-us',
              showSwitcher: false
            });

            hijriYearEst <= 1599
              ? this.informationForm.get('estimara_expiry_date').setValue(estDate)
              : this.informationForm.get('estimara_expiry_date').setValue('');

            this.informationForm.get('estimara_expiry_date').updateValueAndValidity({
              onlySelf: true,
              emitEvent: true
            });
            // END
          }, 0);

          return;
        }

        hijriYearEst > 1599
          ? this.informationForm
              .get('estimara_expiry_date')
              .setValue(this.vinInfo.estimara_expiry_date || '')
          : this.informationForm.get('estimara_expiry_date').setValue('');
        break;
      case 'mvpi':
        const mvpiDate = this.vinInfo.mvpi_expiry_date || '';
        const hijriYearMVPI: string | number = moment(
          this.vinInfo.mvpi_expiry_date,
          'DD-MM-YYYY'
        ).year();
        this.mvpiExpToggle = !this.mvpiExpToggle;

        if (this.mvpiExpToggle) {
          setTimeout(() => {
            // Islamic DP
            $('#mvpi_exp_date').hijriDatePicker({
              hijri: true,
              hijriFormat: 'iD-iM-iYYYY',
              locale: 'en-us',
              showSwitcher: false
            });

            hijriYearMVPI <= 1599
              ? this.informationForm.get('mvpi_expiry_date').setValue(mvpiDate)
              : this.informationForm.get('mvpi_expiry_date').setValue('');

            this.informationForm.get('mvpi_expiry_date').updateValueAndValidity({
              onlySelf: true,
              emitEvent: true
            });
            // END
          }, 0);

          return;
        }

        hijriYearMVPI > 1599
          ? this.informationForm
              .get('mvpi_expiry_date')
              .setValue(this.vinInfo.mvpi_expiry_date || '')
          : this.informationForm.get('mvpi_expiry_date').setValue('');

        break;
    }
  }

  hijriChecker(date: Date | string, type: string) {
    const hijriYear: string | number = moment(date, 'DD-MM-YYYY').year();

    if (hijriYear <= 1599) this.dpToggle(type);
  }

  saveData() {
    let estExpDate: string = null;
    let mvpiExpDate: string = null;

    if (this.estExpToggle) {
      let estExpVal = document.querySelector('#est_exp_date')['value'];
      this.informationForm.get('estimara_expiry_date').setValue(estExpVal);
      this.informationForm.get('estimara_expiry_date').updateValueAndValidity();

      estExpDate = this.informationForm.get('estimara_expiry_date').value
        ? moment(this.informationForm.get('estimara_expiry_date').value, 'DD-MM-YYYY').format(
            'YYYY-MM-DD'
          )
        : '';
    } else {
      estExpDate = this.informationForm.get('estimara_expiry_date').value
        ? moment(this.informationForm.get('estimara_expiry_date').value, 'DD-MM-YYYY').format(
            'YYYY-MM-DD'
          )
        : '';
    }

    if (this.mvpiExpToggle) {
      let mvpiExpVal = document.querySelector('#mvpi_exp_date')['value'];
      this.informationForm.get('mvpi_expiry_date').setValue(mvpiExpVal);
      this.informationForm.get('estimara_expiry_date').updateValueAndValidity();

      mvpiExpDate = this.informationForm.get('mvpi_expiry_date').value
        ? moment(this.informationForm.get('mvpi_expiry_date').value, 'DD-MM-YYYY').format(
            'YYYY-MM-DD'
          )
        : '';
    } else {
      mvpiExpDate = this.informationForm.get('mvpi_expiry_date').value
        ? moment(this.informationForm.get('mvpi_expiry_date').value, 'DD-MM-YYYY').format(
            'YYYY-MM-DD'
          )
        : '';
    }

    this.submitted = true;

    if (this.role === 'reconditioning_manager') {
      const fieldsToClear = [
        'estimara_expiry_date',
        'warranty_id',
        'power_id',
        'torque_id',
        'acceleration_id'
      ];

      fieldsToClear.forEach((field) => {
        const control = this.informationForm.get(field);
        if (control) {
          control.clearValidators();
          control.updateValueAndValidity();
        }
      });
    }

    if (this.informationForm.invalid) {
      return false;
    } else {
      const warrantyExpDate: string = this.informationForm.get('warranty_expiry_date').value
        ? moment(this.informationForm.get('warranty_expiry_date').value, 'DD-MM-YYYY').format(
            'YYYY-MM-DD'
          )
        : '';
      const lastServDate: string = this.informationForm.get('last_service_date').value
        ? moment(this.informationForm.get('last_service_date').value, 'DD-MM-YYYY').format(
            'YYYY-MM-DD'
          )
        : '';

      let information: Object = {};
      let makeElem: HTMLSelectElement = document.querySelector("[name='make_id']");
      let modelElem: HTMLSelectElement = document.querySelector("[name='model_id']");
      let cyllinderElem: HTMLSelectElement = document.querySelector("[name='cyllinder_id']");
      let trimElem: HTMLSelectElement = document.querySelector("[name='trim_id']");
      let modelYrElem: HTMLSelectElement = document.querySelector("[name='model_year_id']");

      information = {
        user_id: this.userData.id,
        vehicle_id: this.vehicle_info.vehicle_id,
        vehicle_item_code:
          `${makeElem.options[makeElem.selectedIndex].text}` +
          ` ${modelElem.options[modelElem.selectedIndex].text}` +
          ` ${cyllinderElem.options[cyllinderElem.selectedIndex].text}` +
          ` ${trimElem.options[trimElem.selectedIndex].text}` +
          ` ${modelYrElem.options[modelYrElem.selectedIndex].text}`,

        ...this.informationForm.value,
        estimara_expiry_date: estExpDate,
        mvpi_expiry_date: mvpiExpDate,
        warranty_expiry_date: warrantyExpDate,
        last_service_date: lastServDate
      };

      this.deleteBodyTypeData(this.informationForm.get('body_type_id').value);

      this.submitLoad = true;
      this.informationService
        .SaveInformation(information)
        .pipe(
          switchMap((res) =>
            res['success']
              ? this.role === 'evaluator'
                ? this.estimateService.updateRevamCount({
                    vehicle_id: this.sharedService.getVehicleId
                  })
                : of(null)
              : EMPTY
          ),
          tap(() => {
            this.sharedService.setVinInfo = {
              ...this.extractInformation(),
              is_salvage: this.vinInfo.is_salvage
            };

            this.router.navigate([`/vam/options`]);
          }),
          finalize(() => {
            this.submitLoad = false;
          })
        )
        .subscribe({
          error: () => {}
        });
    }
  }

  getExtrenalEstimator(vehicle_id) {
    const data = {
      vehicle_id: vehicle_id
    };

    this.userService.GetEstimatorList(data).subscribe((response) => {
      if (response['success']) {
        this.dropdownList = response['data'];

        let selectedData = {
          vehicle_id: this.sharedService.getVehicleId
        };
        this.userService.GetEstimatorList(selectedData).subscribe((selectedResponse) => {
          if (selectedResponse['success']) {
            this.selectedItems = [];
            for (let item of this.dropdownList) {
              for (let selected of selectedResponse['data']) {
                if (item.id == selected.user_uuid) {
                  this.selectedItems.push(item);
                  break;
                }
              }
            }
          }
        });
      }
    });
  }

  onItemSelect(event) {
    const data = {
      vehicle_id: this.vehicle_info.vehicle_id,
      user_uuid: event.id
    };

    this.userService.AddEstimator(data).subscribe();
  }

  onItemDeSelect(event) {
    const data = {
      vehicle_id: this.vehicle_info.vehicle_id,
      user_uuid: event.id
    };

    this.userService.DeleteEstimator(data).subscribe();
  }

  onSelectAll(event) {
    event.forEach((item) => {
      this.onItemSelect(item);
    });
  }

  onDeSelectAll(event) {
    this.dropdownList.forEach((item) => {
      this.onItemDeSelect(item);
    });
  }

  public acceptabilityData: any[] = [];
  getMarketAcceptability() {
    this.informationService.getMarketAcceptability().subscribe((response: any) => {
      if (response?.success) {
        this.acceptabilityData = response.data;
      }
    });
  }
}
